import { ArticleHeading3, ArticleHeading4, Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Subtitle.css';

interface ISubtitleProps {
  children: string;
}

export const Subtitle: React.FC<ISubtitleProps> = ({ children }) => {
  return (
    <div className={styles['subtitle']}>
      <Responsive desktop tablet>
        <ArticleHeading3>{children}</ArticleHeading3>
      </Responsive>
      <Responsive phone>
        <ArticleHeading4>{children}</ArticleHeading4>
      </Responsive>
    </div>
  );
};
